import { useEffect, useState } from "react";
import { RootStateType, AccountInfo } from "@Interfaces";
import { useSelector } from "react-redux";

const useAccountInfo = (): [AccountInfo] => {
    const { account: userAccountInfo } = useSelector(
        (state: RootStateType) => state.auth.user
    );

    const [account, setAccount] = useState(userAccountInfo);

    useEffect(() => {
        setAccount(userAccountInfo);
    }, [userAccountInfo]);

    return [account];
};

export default useAccountInfo;
